<template>
  <div id="listRadio">
    <div id="title">
      <slot name="title"></slot>
    </div>
    <div id="itemList">
      <slot name="itemList"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ListRadio"
  }
</script>

<style scoped>
  #listRadio{
    border: 1px solid #c0c1c2;
    width: 200px;
    font-size: 0.875rem;
  }
  #title{
    text-align: center;
    width: 200px;
    height: 37px;
    line-height: 37px;
    background-color: #dddedf;
    opacity: 0.5;
    border-bottom: 1px solid #c0c1c2;
  }
  #itemList{
    width: 200px;
    text-align: center;
  }
</style>
